/**
 * This function maps contenful asset data
 * to CfAsset model constructor data.
 * @export
 * @param {*} [cfEntity={}]
 * @returns {Object}
 */
export function mapCfEntityToCfAsset(cfEntity = {}) {
    const { fields } = cfEntity;

    const { file, title } = fields || {};

    const {
        contentType,
        url,
        details: { image },
    } = file || {};

    return {
        url,
        contentType,
        image,
        title,
    };
}
